import styled from "styled-components";

export const ReceiptContainer = styled.div`
  width: 100%;
  background-color: #f9f9f9;
  border-radius: 10px;
  font-family: "Arial", sans-serif;
  overflow: hidden;
`;

export const Content = styled.div`
  padding: 20px;
  font-size: 14px;
  color: #333;
`;

export const Divider = styled.div`
  margin: 12px 0;
  ${({ variant }) => {
    switch (variant) {
      case "double":
        return `
          border-top: 2px double #ccc
        `;
      default:
        return `
          border-top: 1px dashed #ccc;
        `;
    }
  }}
`;

export const Footer = styled.div`
  text-align: center;
  font-size: 12px;
  color: #888;
  padding: 10px 0;
`;

export const ReceiptRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
`;

export const GridRow = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px; 
  margin-bottom: 5px;

  text-align: right;

  :first-child {
    text-align: left;  
  }
`

export const Highlight = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 20px;
  margin: 10px 0;
  color: #000;
`;